<template>
    <v-card tile elevation="4" class="pa-0">
        <v-toolbar short flat color="white">
            <v-toolbar-title class="blue--text">{{label}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="blue" @click="onClickCreateAccount" v-if="isCreateEnabled">
                <font-awesome-icon icon="plus" style="font-size: 20px;" fixed-width/>
            </v-btn>
        </v-toolbar>
        <!-- <v-divider></v-divider> -->
        <v-list dense nav>
            <v-list-item v-if="list.length === 0">No accounts yet.</v-list-item>
            <v-list-item v-for="item in list" v-bind:key="item.id" class="my-2" @click="onClickItem(item.id)">
                <v-list-item-content>
                    <AccountListItem :attr="item" :link="!selectOne"></AccountListItem>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-row justify="center" class="py-5" v-show="displayCreateAccount">
            <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
            <v-card elevation="4" class="px-10 pb-5 pt-8">
                <v-form v-model="createAccountForm" ref="createAccountFormRef" @submit="validateCreateAccount" onSubmit="return false;" @keyup.enter.native="validateCreateAccount">
                    <div v-if="add">
                        <v-select :items="addAccountChoices" v-model="addAccountId" label="Select an account"></v-select>
                    </div>
                    <div v-if="create">
                        <!--
                        <v-text-field
                            v-model=name
                            label="Name"
                            :rules="nameRules"
                            validate-on-blur
                            color="blue"
                            required
                            hint="What should we call you?"
                            autofocus
                            outlined
                        >
                                            <template v-slot:prepend>
                        <font-awesome-icon icon="account" fixed-width class="mt-1"/>
                    </template>
                        </v-text-field>
                        -->
                        <v-text-field
                            ref="nameInputRef"
                            v-model=newAccountName
                            label="Display Name"
                            :rules="newAccountNameRules"
                            validate-on-blur
                            color="blue"
                            required
                            hint="The name for the account"
                            type="text"
                            outlined
                        >
                        </v-text-field>

                    </div>
                    <v-row justify="center">
                        <v-card-actions>
                            <v-btn elevation="4" class="blue white--text" @click="addAccount" :disabled="!createAccountForm" v-if="add">
                                <font-awesome-icon icon="check" fixed-width/>
                                <span class="ml-2">Add</span>
                            </v-btn>
                            <v-btn elevation="4" class="blue white--text" @click="createAccount" :disabled="!createAccountForm" v-if="create">
                                <font-awesome-icon icon="check" fixed-width/>
                                <span class="ml-2">Create</span>
                            </v-btn>
                        </v-card-actions>
                    </v-row>
                </v-form>
            </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import AccountListItem from '@/components/list-item/AccountListItem.vue';
import { isValidName, compact } from '@/sdk/input';

export default {
    components: {
        AccountListItem,
    },

    props: {
        // optional; use this when you want to use the account list to select an account; emits 'selected' when user taps on an account
        selectOne: {
            type: Boolean,
            default: false,
        },
        // optional; true means the 'plus' button will be for adding a user to a list
        add: {
            type: Boolean,
            default: false,
        },
        // optional; true means the 'plus' button will be allowed to create new user records if they don't already exist
        create: {
            type: Boolean,
            default: false,
        },
        createRoute: {
            type: Object,
            default: null,
        },
        // policyId is optional; when provided, the create account dialog functions as an 'add or create' dialog and allows user to choose from an existing account to add to the list, or create a new account
        policyId: {
            type: String,
        },
        list: {
            type: Array,
        },
    },

    data() {
        return {
            // list: [],
            // create account
            displayCreateAccount: false,
            createAccountForm: null,
            newAccountName: null,
            newAccountNameRules: [
                (v) => !!v || 'Display name is required',
                (v) => !v || isValidName(compact(v)) || 'Account name is required',
            ],
            // add account
            addAccountChoices: [],
            addAccountId: null,
        };
    },

    computed: {
        id() {
            return this.policyId;
        },
        label() {
            if (this.selectOne) {
                return 'Select an account';
            }
            switch (this.list.length) {
            case 0:
                return 'No accounts';
            case 1:
                return '1 account';
            default:
                return `${this.list.length} accounts`;
            }
        },
        isCreateEnabled() {
            return this.add || this.create || this.createRoute;
        },
    },

    methods: {
        onClickItem(accountId) {
            // if (this.selectOne) {
            //     this.$emit('selected', { accountId });
            // }
            this.$router.push({ name: 'account-dashboard', params: { accountId } });
        },
        onClickCreateAccount() {
            if (typeof this.createRoute === 'object') {
                this.$router.push(this.createRoute);
            } else {
                this.displayCreateAccount = true;
            }
        },
        async createAccount() {
            this.error = false;
            console.log('createAccount');
            const request = {
                // name: this.name,
                name: this.newAccountName,
                // agreeToTerms: this.isAgreeToTermsChecked,
                // interactionId: this.interactionId, // will be present if account arrives from an existing interaction, such as clicking on a specific link to get started and we can use this to redirect the account to an appropriate location after account is created
            };
            const response = await this.$client.user(this.$store.state.session.userId).user.createAccount(request);
            console.log('createAccount response: %o', response);
            const { isCreated, id, error } = response;
            if (isCreated) {
                const account = { id, ...request };
                this.list.push(account);
                this.$emit('created-account', account);
                this.$emit('added-account', account);
                this.displayCreateAccount = false;
                this.newAccountName = null;
            } else if (error) {
                this.error = error;
            } else {
                this.error = 'Request failed';
            }
        },
        validateCreateAccount() {
            if (this.$refs.createAccountFormRef.validate()) {
                this.createAccount();
            }
        },

        async addAccount() {
            const account = { id: this.addAccountId, label: this.addAccountChoices.find((item) => item.value === this.addAccountId).text };
            this.list.push(account);
            this.$emit('added-account', account);
            this.displayCreateAccount = false;
            this.addAccountId = null;
        },
        async initAddAccountChoices() {
            // create a map of which account ids are already in the list
            const accountMap = {};
            this.list.forEach((item) => {
                accountMap[item.id] = true;
            });
            // when we show the add/create account dialog, load the list of available accounts to add to the policy (list of all accounts less the ones already in the policy)
            const result = await this.$client.user(this.$store.state.session.userId).user.getAccountList();
            console.log(`AccountViewList.vue fetch accounts result: ${JSON.stringify(result)}`);
            if (result && result.list) {
                // filter the results to remove accounts already in the policy, then convert the available accounts to a choice list for the v-select [ { text, value }, ... ]
                this.addAccountChoices = result.list.filter((item) => !accountMap[item.id]).map((item) => ({ text: item.name, value: item.id }));
            }
        },
    },

    watch: {
        displayCreateAccount(value) {
            if (value && (this.add || this.create)) {
                this.initAddAccountChoices();
            }
        },
    },
};
</script>
